import classNames from 'classnames';
import useControllableState from 'helpers/hooks/useControllableState';

interface Props extends Omit<React.ComponentProps<'input'>, 'key'> {
  className?: string;
  inputClassName?: string;
  onChecked?: () => void;
}

const Radio: React.FC<Props> = ({
  className = '',
  inputClassName = '',
  onChecked,
  children,
  checked: checkedProp,
  defaultChecked = false,
  onChange,
  ...props
}) => {
  const [checked, setChecked] = useControllableState(checkedProp, defaultChecked);

  const labelClassName = classNames(
    'grid place-content-center w-5 h-5 border border-secondary-black rounded-full',
    className,
  );

  const inputClassNames = classNames('h-3 w-3 border-0 text-secondary-black', inputClassName);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    onChecked?.();
    setChecked(true);
  };

  return (
    <label className={labelClassName} htmlFor={props.id}>
      <input
        style={{ background: checked ? '#494949' : 'white' }}
        className={inputClassNames}
        type="radio"
        checked={checked}
        onChange={(e) => handleChange(e)}
        {...props}
      />
      {children}
    </label>
  );
};

export default Radio;
